import { render, staticRenderFns } from "./cedis_productos.vue?vue&type=template&id=39756791&scoped=true&"
import script from "./cedis_productos.vue?vue&type=script&lang=js&"
export * from "./cedis_productos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39756791",
  null
  
)

export default component.exports